import { gql } from '~src/generated/portal/gql';

export const testSubscription = gql(`
  subscription TestSubscription($projectId: String!) {
    testUpdated {
      test(projectId: $projectId) {
        projectId
        name
        __typename
        id
        timestamp
        version {
          major
          minor
          patch
        }
        preCertificationTestStatus {
          lastRunStatus {
            result
            firmwareVersion
          }
          statusInRc {
            result
            firmwareVersion
          }
        }
        certificationTestStatus {
          lastRunStatus {
            id
            result
            firmwareVersion
          }
          statusInRc {
            id
            result
            firmwareVersion
          }
        }
        projectId
      }
    }
  }
`);
